<template>
    <div class="row mt-3">
        <div class="col-12 col-md-2 mb-4">
            <ul class="nav nav-pills flex-column">
                <li v-for="(tab, index) in serviceTypesFiltered" class="nav-item" :key="index">
                    <router-link tag="a"
                                 :to="{
                                    name:'locationEditServiceTimes',
                                    params: {
                                        serviceTypeIdentifier: tab.identifier,
                                    }
                                 }"
                                 class="nav-link"
                                 :class="{active:tab.identifier === serviceTypeIdentifier}"
                    >
                        {{tab.display_name}}
                    </router-link>
                </li>
            </ul>
        </div>
        <div v-if="serviceTypeIdentifier" class="col-12 col-md-10">
            <b-alert v-if="serviceTypeUnavailable" variant="danger" show>
                U heeft onvoldoende rechten om de service tijden van type '{{ serviceTypeIdentifier }}' te bekijken.
            </b-alert>

            <edit-service-times-for-type v-else :location="location" :service-type="selectedServiceType" :use-cut-off="!!selectedServiceType.is_cutoff" :key="serviceTypeIdentifier"/>
        </div>
    </div>
</template>

<script>
const CACHE_LAST_SELECTED_SERVICE_TYPE = 'lastSelectedLocationServiceType';

import EditServiceTimesForType from "./EditServiceTimesForType";
export default {
    name: "EditServiceTimesLayout",
    components: {EditServiceTimesForType},
    props: {
        location: {required: true, type: Object},
        serviceTypes: {required: true, type: Array},
        serviceTypeIdentifier: {required: false},
    },

    mounted() {
        this.serviceTypeIdentifier = localStorage.getItem(CACHE_LAST_SELECTED_SERVICE_TYPE) ?? null;

        if (!this.serviceTypeIdentifier) {
            this.serviceTypeIdentifier = this.serviceTypesFiltered[0].identifier
        }

        if ((!this.serviceTypesFiltered.some(type => type.identifier === this.serviceTypeIdentifier)) && (this.serviceTypesFiltered.length > 0)) {
            /**
             * Requested service type doesn't exist for current location, fallback to the first service type
             */
            this.serviceTypeIdentifier = this.serviceTypesFiltered[0].identifier
        }

        this.$router.push({
            name: this.$route.name,
            params: {
                serviceTypeIdentifier: this.serviceTypeIdentifier
            }
        })

        if (!this.serviceTypesFiltered.some(type => type.identifier === this.serviceTypeIdentifier)) {
            this.serviceTypeUnavailable = true
        }
    },

    data() {
        return {
            serviceTypeUnavailable: false,
        }
    },

    computed: {
        selectedServiceType() {
            return this.location.location_type.service_types
                .filter(type => type.identifier === this.serviceTypeIdentifier)
                ?.[0] ?? {}
        },
        serviceTypesFiltered() {
            return this.$parent.availableServiceTypes.sort((a,b) => {
                if (a.gui_sort_order > b.gui_sort_order) return 1
                if (a.gui_sort_order < b.gui_sort_order) return -1
                return 0
            })
        },
    },

    methods: {},

    watch: {
        serviceTypeIdentifier(val) {
            this.serviceTypeUnavailable = false

            localStorage.setItem(CACHE_LAST_SELECTED_SERVICE_TYPE, val);
        },
    },
}
</script>

<style scoped>
a.active {
    font-weight: bold;
}
</style>
